import axios from "axios";
import api from "../utils/axiosInterceptor";
const API_URL = process.env.REACT_APP_API_URL;
export const submitRatting = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/address`, data, {});
		return response.data;
	} catch (error) {
		console.error("Error in submitRating function:", error);
		return error.response && error.response.data ? error.response.data : {status: false, message: error.message};
	}
};

export const addressAndRatingDetails = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/rating-detail`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in addressAndRatingDetails function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const editAddressAndRating = async (data) => {
	try {
		const response = await api.put(`${API_URL}/api/address/edit/${data.id}`, data, {});
		return response.data;
	} catch (error) {
		console.error("Error in editAddressAndRating function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const deleteAddressAndRating = async (id) => {
	try {
		const response = await api.delete(`${API_URL}/api/ratings/${id}`, {});
		return response.data;
	} catch (error) {
		console.error("Error in deleteAddressAndRating function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const submitStreetZipComment = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/submit-street-zip-comment`, data, {});
		return response.data;
	} catch (error) {
		console.error("Error in submitRating function:", error);
		return error.response && error.response.data ? error.response.data : {status: false, message: error.message};
	}
};

export const getDataBaseAddress = async (data) => {
	try {
		// const response = await api.get(`${API_URL}/api/custom-address-search`, {
		const response = await api.get(`${API_URL}/api/job-site/address-search`, {
			params: {query: data},
		});
		return response;
	} catch (error) {
		console.error("Error in submitRating function:", error);
		return error.response && error.response.data ? error.response.data : {status: false, message: error.message};
	}
};

export const getDataBaseAddressWithStreetZip = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/custom-address-street-zip-search`, {
			params: {query: data},
		});
		return response;
	} catch (error) {
		console.error("Error in submitRating function:", error);
		return error.response && error.response.data ? error.response.data : {status: false, message: error.message};
	}
};

export const addressCommentDetails = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/street-zip-comment`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in addressAndRatingDetails function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const MyRepliesCommentDetails = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/replies/street-zip-comment`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in addressAndRatingDetails function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const editAddressStreetZip = async (data) => {
	try {
		const response = await api.put(`${API_URL}/api/street-zip-comment/${data.id}`, data, {});
		return response.data;
	} catch (error) {
		console.error("Error in editAddressAndRating function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const deleteAddressStreetZip = async (id) => {
	try {
		const response = await api.delete(`${API_URL}/api/street-zip-comment/${id}`, {});
		return response.data;
	} catch (error) {
		console.error("Error in deleteAddressAndRating function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const getDataReviewOrtreetZip = async (id, addresses_string) => {
	try {
		const response = await api.post(
			`${API_URL}/api/get-reviews-street-zip-comment`,
			{
				id: id,
				addresses_string: addresses_string,
			},
			{}
		);
		return response.data;
	} catch (error) {
		console.error("Error in deleteAddressAndRating function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const likeService = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/like`, {
			params: data,
		});
		return response;
	} catch (error) {
		console.error("Error in submitRating function:", error);
		return error.response && error.response.data ? error.response.data : {status: false, message: error.message};
	}
};

export const upliftService = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/uplift`, {
			params: data,
		});
		return response;
	} catch (error) {
		console.error("Error in submitRating function:", error);
		return error.response && error.response.data ? error.response.data : {status: false, message: error.message};
	}
};

export const activityList = async (data) => {
	try {
		const response = await api.get(`${API_URL}/activity/get`, {
			params: data,
		});
		return response;
	} catch (error) {
		console.error("Error in submitRating function:", error);
		return error.response && error.response.data ? error.response.data : {status: false, message: error.message};
	}
};

export const verificationService = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/verification`, {
			params: data,
		});
		return response;
	} catch (error) {
		console.error("Error in submitRating function:", error);
		return error.response && error.response.data ? error.response.data : {status: false, message: error.message};
	}
};

export const CommentToCommentModify = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/comment-to-comment/modify`, data, {});
		return response;
	} catch (error) {
		console.error("Error in submitRating function:", error);
		return error.response && error.response.data ? error.response.data : {status: false, message: error.message};
	}
};

export const getWealthFactorService = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/ai/wealth/factor`, {
			params: data,
		});
		return response;
	} catch (error) {
		console.error("Error in submitRating function:", error);
		return error.response && error.response.data ? error.response.data : {status: false, message: error.message};
	}
};

export const BusinessAddressVerification = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/business/address/verification`, data, {});
		return response.data;
	} catch (error) {
		console.error("Error in submitRating function:", error);
		return error.response && error.response.data ? error.response.data : {status: false, message: error.message};
	}
};
